export function convertPrice(price: string | number | null, round: boolean = false): number | null {
	if (price) {
		const value = price + '';
		const a = +(value.replace(/ /g, '')) || 0;

		if (round) {
			return Math.floor(a);
		}

		return a;
	}

	if (price === 0) {
		return 0;
	}

	return null;
}
